export const loadingSelector = state => !!state.loading;
